/**
 * Display-only translations keyed by stable flow element id and field.
 * Canonical flow text remains authoritative for evaluation and stored answers.
 */
export type FlowElementTextOverlay = Record<string, Record<string, string>>;

export const FLOW_ELEMENT_TRANSLATABLE_FIELDS = [
  "message",
  "description",
  "name",
  "header",
  "continueButtonText",
  "customQuestion",
  "customExplanationSubtext",
  "customRegexErrorMessage",
] as const;

export type FlowElementTranslatableField =
  (typeof FLOW_ELEMENT_TRANSLATABLE_FIELDS)[number];
